<template>
  <v-btn
    class="mx-0 mx-md-1"
    active-class="primary"
    :to="{ name: chip == 'featured' ? 'menu' : chip }"
    :exact="chip !== 'menu'"
    :small="$vuetify.breakpoint.smAndDown"
    :large="$vuetify.breakpoint.mdAndUp"
    rounded
    text
  >
    <div class="font-size-md text-capitalize e2e-navigation-button">
      {{ chip }}
    </div>
  </v-btn>
</template>

<script>
export default {
  name: "NavChip",
  props: { chip: String },
};
</script>
